import { Component, ContentChildren, EventEmitter, Input, Output, QueryList } from '@angular/core';
import { WizardStepComponent } from './wizard-step/wizard-step.component';

@Component({
    selector: 'c-wizard',
    templateUrl: './wizard.component.html',
    styleUrls: ['./wizard.component.scss'],
    standalone: false
})
export class WizardComponent {
  @Input() activeStep: string; // name of active step
  @Input() title = ''; // title to show above the steps

  @Output() buttonClick: EventEmitter<any> = new EventEmitter();

  @ContentChildren(WizardStepComponent) set wizardSteps(wizardSteps: QueryList<WizardStepComponent>) {
    this.wizardStepNames = wizardSteps?.map((step) => step.name);
  }

  wizardStepNames: string[] = [];
}
